import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { AjouteSociete } from '../../Redux/actions/actionSociete';
import { LoginSocieteRequest } from '../../Api/AuthSociete';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../Css/loginSociete.css';

const LoginSociete = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);


  let location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();



  const handlePassword = () => setShowPass(!showPass);
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = { email: email, password: password };
    LoginSocieteRequest(data).then(function (response) {
      console.log(response);
      localStorage.setItem('societe', JSON.stringify(response.data.donner));
      localStorage.setItem('tokenSociete', response.data.token);
      dispatch(AjouteSociete(response.data.donner));
      if (response.data.title === "success") {
        navigate('/societe/parametrage');
      }
    }).catch(function (error) {
      console.log(error);
      if (error) {
        toast.error(error.response.data?.message);
      }
    }).finally(function () {
      setLoading(false);
    });

  }
  return (
    <div>
      <Helmet>
        <title>Société ~ Login</title>
        <meta name='description' content='Login société.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='login_societe'>
        {loading && <Loader />}
        <div className='col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 mx-auto layout_form'>
          <div className='bloc_form'>
            <div className='d-flex justify-content-center'>
              <h1>Admin Societe</h1>
            </div>
            <form onSubmit={handleSubmit} className='form_content'>
              <div className="mb-3">
                <div className='d-flex justify-content-start'>
                  <label className="form-label">Adresse e-mail</label>
                </div>
                <input type="email" className="form-control" required id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Adresse e-mail ..." />
              </div>
              <div className="mb-3">
                <div className='d-flex justify-content-start'>
                  <label className="form-label">Mot de passe</label>
                </div>
                <input type={showPass ? "text" : "password"} required value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" id="password" placeholder="Mot de passe ..." />
              </div>
              <div className='d-flex justify-content-end'>
                <i className={showPass ? 'fa fa-eye-slash' : 'fa fa-eye'} onClick={handlePassword} ></i>
              </div>
              <button type='submit' className='btn w-100'>Connexion</button>
              <p className="version">Version 1</p>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginSociete